import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSuitcase = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18 3H14.25V2.25C14.25 1.65326 14.0129 1.08097 13.591 0.65901C13.169 0.237053 12.5967 0 12 0H7.5C6.90326 0 6.33097 0.237053 5.90901 0.65901C5.48705 1.08097 5.25 1.65326 5.25 2.25V3H1.5C1.10218 3 0.720644 3.15804 0.43934 3.43934C0.158035 3.72064 0 4.10218 0 4.5V16.5C0 16.8978 0.158035 17.2794 0.43934 17.5607C0.720644 17.842 1.10218 18 1.5 18H18C18.3978 18 18.7794 17.842 19.0607 17.5607C19.342 17.2794 19.5 16.8978 19.5 16.5V4.5C19.5 4.10218 19.342 3.72064 19.0607 3.43934C18.7794 3.15804 18.3978 3 18 3ZM6.75 2.25C6.75 2.05109 6.82902 1.86032 6.96967 1.71967C7.11032 1.57902 7.30109 1.5 7.5 1.5H12C12.1989 1.5 12.3897 1.57902 12.5303 1.71967C12.671 1.86032 12.75 2.05109 12.75 2.25V3H6.75V2.25ZM12.75 4.5V16.5H6.75V4.5H12.75ZM1.5 4.5H5.25V16.5H1.5V4.5ZM18 16.5H14.25V4.5H18V16.5Z",
		fill: "current"
	})
});
export default SvgSuitcase;
